import React, { useCallback, useContext, useEffect, useState } from 'react'
import '../assets/css/CookieBanner.css'
import { getLocalStorage, setLocalStorage } from '../services/StorageHelper'
import { CookieConsentContext } from '../context/CookieConsentContext'

const deniedConsent = {
    'ad_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'analytics_storage': 'denied',
    'personalization_storage': 'denied',
    'functionality_storage': 'denied',
    'security_storage': 'denied',
}
const grantedConsent = {
    'ad_storage': 'granted',
    'ad_user_data': 'granted',
    'ad_personalization': 'denied',
    'analytics_storage': 'granted',
    'personalization_storage': 'denied',
    'functionality_storage': 'granted',
    'security_storage': 'denied',
}

function CookieBanner() {
    const { cookieConsentMode, setCookieConsentMode } = useContext(CookieConsentContext);

    useEffect (() => {
        const storedCookieConsent = getLocalStorage("cookieConsentMode", null);
        if (storedCookieConsent === true || storedCookieConsent === 'true') {
            setCookieConsentMode(true);
        } else if (storedCookieConsent === false || storedCookieConsent === 'false') {
            setCookieConsentMode(false);
        } else {
            setCookieConsentMode(null);
        }
    }, [])

    
    useEffect(() => {
        if (cookieConsentMode === null ) return;
        const newValue = cookieConsentMode ? grantedConsent : deniedConsent;
        if (window.gtag) {
            window.gtag("consent", 'update', newValue);
        }
        setLocalStorage("cookieConsentMode", cookieConsentMode);
    }, [cookieConsentMode])
  
    const handleConfirm = useCallback(() => {  
        setCookieConsentMode(true)
    }, [setCookieConsentMode])

    const dismissBanner = useCallback(() => {
        setCookieConsentMode(false)
    }, [setCookieConsentMode])

    if (cookieConsentMode !== null) {
        return null;
    }

    return (
        <div>
            <div className="cookie-banner flex-container center-justify">
                <div className='flex-container cookie-banner-content center-align center-justify full-width'>
                    <p className='text-center'>
                        Koristimo kolačiće u analitičke svrhe i za prikazivanje oglasa. Pročitajte našu
                        <a href={process.env.REACT_APP_HISTORIOGRAFIJA_FRONTEND + "politika-privatnosti"}>
                            politiku privatnosti.
                        </a>
                    </p>
                    <div className='button-div flex-container'>
                        <button type='button' className="agree-btn" onClick={handleConfirm}>
                            Prihvati
                        </button>
                        <button type='button' className="disagree-btn" onClick={dismissBanner}>
                            Odbij
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CookieBanner
